var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 105,
    viewBox: "0 0 101 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.4878 45.9186C88.9064 69.5694 53.1252 98.0499 29.6764 92.5161C6.22761 86.9823 6.13728 62.3924 11.7188 38.7416C17.3002 15.0907 26.4399 1.33502 49.8887 6.86881C73.3375 12.4026 100.069 22.2677 94.4878 45.9186Z",
    fill: "#F5FAF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.052 49.3509H54.0915L49.5298 41.3674C49.469 41.2611 49.3812 41.1728 49.2752 41.1114C49.1693 41.0499 49.049 41.0176 48.9265 41.0176H46.0837C45.6223 41.0176 45.2894 41.459 45.4161 41.9026L47.5442 49.3509H43.0797L41.2047 46.8509C41.0737 46.676 40.8675 46.5731 40.6492 46.5731H38.9135C38.4617 46.5731 38.1301 46.9976 38.2399 47.436L39.6075 52.1287L38.2399 56.8214C38.1301 57.2598 38.4617 57.6842 38.9135 57.6842H40.6492C40.8679 57.6842 41.0737 57.5814 41.2047 57.4065L43.0797 54.9065H47.5442L45.4161 62.3544C45.2894 62.798 45.6223 63.2398 46.0837 63.2398H48.9265C49.1757 63.2398 49.4057 63.1061 49.5294 62.89L54.0915 54.9065H59.052C60.5863 54.9065 63.2186 53.663 63.2186 52.1287C63.2186 50.5944 60.5863 49.3509 59.052 49.3509Z",
    fill: "#EBA10F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIcon2);
export default __webpack_public_path__ + "static/media/heroIcon2.d35bd4862a17058c40205c732b28f103.svg";
export { ForwardRef as ReactComponent };